'use client';

import { useParams, usePathname } from 'next/navigation';
import { FC, useLayoutEffect } from 'react';

import { useAnalytics } from '@/hooks/analytics/useAnalytics';
import { logCalmEventProperties } from '@/utils/analytics/calm';

const InitialPageAnalytics: FC = () => {
	const pathname = usePathname();
	const { logEvent } = useAnalytics();
	const params = useParams<{ partnerId: string }>();
	const partnerId = params?.partnerId;

	useLayoutEffect(() => {
		// Log base event props - like the device id
		logCalmEventProperties();
		// Log the base page view
		const pageName = pathname?.replace('/', '').replace(`${partnerId}/`, '') ?? 'unknown';
		logEvent('Page : Viewed', {
			page_name: pageName,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname]);

	return <></>;
};

export default InitialPageAnalytics;
